export function requestDeadline(milliseconds, parent) {
  const controller = new AbortController();
  const duration = Number.isFinite(Number(milliseconds)) ? Math.max(1, Number(milliseconds)) : 1;
  const expires = Date.now() + duration;
  const abort = () => controller.abort(parent.reason);
  const timer = setTimeout(() => controller.abort(Object.assign(new Error('Request timed out'), {name: 'TimeoutError', statusCode: 504})), duration);
  parent?.addEventListener('abort', abort, {once: true});
  if (parent?.aborted) abort();
  return {signal: controller.signal, remaining: () => Math.max(0, expires - Date.now()), close() {clearTimeout(timer); parent?.removeEventListener('abort', abort);}};
}

export function awaitWithSignal(promise, signal) {
  const pending = Promise.resolve(promise);
  if (!signal) return pending;
  if (signal.aborted) {pending.catch(() => {}); return Promise.reject(signal.reason);}
  return new Promise((resolve, reject) => {
    const cancel = () => {signal.removeEventListener('abort', cancel); reject(signal.reason);};
    signal.addEventListener('abort', cancel, {once: true});
    pending.then(value => {signal.removeEventListener('abort', cancel); resolve(value);}, error => {signal.removeEventListener('abort', cancel); reject(error);});
  });
}
